import React, { FC, memo } from "react";

import { TitleContainer } from "../../containers/TitleContainer";
import { isVisibleContainer } from "../../utils/isVisibleContainer";
import { useWidgetContext } from "../../../Dashboard/hooks/useWidgetContext";
import { ExpandableTitleProps } from "./types";

export const ExpandableTitle: FC<ExpandableTitleProps> = memo(({ elementConfig, type, renderElement }) => {
  const { expandedContainers } = useWidgetContext(type);

  const { id, options, templateName, children } = elementConfig || {};
  const { expandable, fontColor, expanded, layerNames } = options || {};

  const titleElement = children?.find(item => item?.id === "title");
  const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

  if (!titleElement) return null;

  return (
    <TitleContainer
      containerId={id}
      elementConfig={titleElement}
      templateName={templateName}
      layerNames={layerNames}
      fontColor={fontColor}
      expandable={expandable}
      expanded={expanded}
      type={type}
      isVisible={isVisible}
      renderElement={renderElement}
    />
  );
});
